import moment from 'moment';
import { saveSearchDetails } from '@shared/redux/actions';
import { postMetaConverter } from '@shared/services/meta';

export const submitHotelSearch = ({
  calendarValue,
  passengerValue,
  lodgingSelection,
  roomInfo,
  quantity,
  dispatch,
  setHasError,
  setReady,
  searchInfo,
  needsNavigate,
  user,
  fetchData,
  setShowRooms,
}) => {
  if (setShowRooms) {
    setShowRooms(false);
  }

  const isValidCheckIn = moment(
    calendarValue.check_in,
    'YYYY-MM-DD',
    true
  ).isValid();
  const isValidCheckOut = moment(
    calendarValue.check_out,
    'YYYY-MM-DD',
    true
  ).isValid();
  const hasCitySelected = Boolean(lodgingSelection?.option?.id);

  if (!isValidCheckIn || !isValidCheckOut || !hasCitySelected) {
    setHasError(true);
    setReady?.(false);
    return;
  }

  const selectedOption =
    lodgingSelection.option?.reference_city || lodgingSelection.option;

  dispatch(
    saveSearchDetails({
      checkIn: calendarValue.check_in,
      checkOut: calendarValue.check_out,
      totalNights: calendarValue.total_nights,
      passengers: passengerValue.passengers,
      totalPassengers: passengerValue.total_passengers,
      search_option:
        Object.keys(lodgingSelection ?? {}).length > 0
          ? lodgingSelection
          : searchInfo?.search_option,
      roomInfo,
      quantity,
      city: {
        id: selectedOption?.id,
        label: lodgingSelection.option?.label,
        country: selectedOption?.country,
        name: selectedOption?.city,
        countryOfResidence: 'AR',
      },
      searchId: Date.now(),
    })
  );

  const analyticsData = {
    fecha_busqueda: moment().format('DD-MM-YYYY'),
    fecha_ingreso: calendarValue.check_in,
    fecha_salida: calendarValue.check_out,
    total_noches: calendarValue.total_nights,
    total_pasajeros: passengerValue.total_passengers,
    destino: lodgingSelection?.option?.label,
    habitaciones: roomInfo,
  };

  window.dataLayer?.push?.({
    event: 'hotelBusqueda',
    eventProps: {
      category: 'hotels',
      action: 'search',
      label: 'buscar',
      value: analyticsData,
    },
  });

  postMetaConverter(
    {
      event_name: 'hotelBusqueda',
      custom_data: {
        category: 'hotels',
        action: 'search',
        label: 'buscar',
        ...analyticsData,
      },
    },
    { user }
  );

  setHasError(false);

  if (needsNavigate) {
    setReady(true);
  } else {
    fetchData();
  }
};
